/** @deprecated **/
// @ts-ignore
var AudioContext = window.AudioContext || window.webkitAudioContext;
var ZZFXLib = /** @class */ (function () {
    function ZZFXLib() {
        if (!ZZFXLib.context) {
            ZZFXLib.context = new AudioContext();
        }
        this.r = Date.now(); // starting value for random numbers
        this.buffer = undefined; // last sound buffer
        this.volume = 0.5; // master volume scale
        this.randomness = 0.1; // default frequency randomness
    }
    ZZFXLib.state = function () {
        if (!ZZFXLib.context) {
            ZZFXLib.context = new AudioContext();
        }
        return ZZFXLib.context.state;
    };
    ZZFXLib.resume = function () {
        if (!ZZFXLib.context) {
            ZZFXLib.context = new AudioContext();
        }
        return ZZFXLib.context.resume();
    };
    // play seeded sound with overrides applied
    ZZFXLib.prototype.z = function (seed, soundOverrides) {
        if (DEVELOPMENT) {
            // @ts-ignore
            window['playSoundTime'] = Date.now();
        }
        // generate sound from seed
        var sound = this.Generate(seed);
        // copy overrides to sound
        for (var setting in soundOverrides) {
            if (soundOverrides.hasOwnProperty(setting)) {
                // @ts-ignore
                sound[setting] = soundOverrides[setting];
            }
        }
        // play sound
        return this.Z(
        // @ts-ignore-start
        sound['volume'], sound['randomness'], sound['frequency'], sound['length'], sound['attack'], sound['slide'], sound['noise'], sound['modulation'], sound['modulationPhase']
        // @ts-ignore-end
        );
    };
    // play sound with full parameter control
    ZZFXLib.prototype.Z = function (volume, randomness, frequency, length, attack, slide, noise, modulation, modulationPhase) {
        if (length === void 0) { length = 1; }
        if (attack === void 0) { attack = 0.1; }
        if (slide === void 0) { slide = 0; }
        if (noise === void 0) { noise = 0; }
        if (modulation === void 0) { modulation = 0; }
        if (modulationPhase === void 0) { modulationPhase = 0; }
        // normalize parameters
        var sampleRate = 44100;
        volume *= this.volume;
        frequency *= (2 * Math.PI) / sampleRate;
        frequency *= 1 + randomness * (this.R() * 2 - 1);
        slide *= (Math.PI * 1e3) / Math.pow(sampleRate, 2);
        length = length > 0 ? ((length > 10 ? 10 : length) * sampleRate) | 0 : 1;
        attack *= length | 0;
        modulation *= (2 * Math.PI) / sampleRate;
        modulationPhase *= Math.PI;
        // generate waveform
        var b = [], f = 0, fm = 0;
        for (var F = 0; F < length; ++F) {
            b[F] =
                volume * // volume
                    Math.cos(f *
                        frequency * // frequency
                        Math.cos(fm * modulation + modulationPhase)) * // modulation
                    (F < attack
                        ? F / attack // attack
                        : 1 - (F - attack) / (length - attack)); // decay
            f += 1 + noise * (this.R() * 2 - 1); // noise
            fm += 1 + noise * (this.R() * 2 - 1); // modulation noise
            frequency += slide; // frequency slide
        }
        // play sound
        this.buffer = b;
        var B = ZZFXLib.context.createBuffer(1, b.length, sampleRate);
        var S = ZZFXLib.context.createBufferSource();
        B.getChannelData(0).set(b);
        S.buffer = B;
        S.connect(ZZFXLib.context.destination);
        S.start();
        return S;
    };
    // generate sound from seed
    ZZFXLib.prototype.Generate = function (seed) {
        var rSave = this.r; // save the seed
        this.r = seed; // set our seed
        for (var i = 9; i--;)
            this.R(); // warm it up
        // generate parameters
        var sound = {};
        sound['seed'] = seed;
        sound['volume'] = 1;
        sound['randomness'] = seed ? this.randomness : 0;
        sound['frequency'] = seed ? (Math.pow(this.R(), 2) * 2e3) | 0 : 220;
        sound['slide'] = seed ? parseFloat((Math.pow(this.R(), 3) * 10).toFixed(1)) : 0;
        sound['length'] = seed ? parseFloat((0.1 + this.R()).toFixed(1)) : 1;
        sound['attack'] = seed ? parseFloat(this.R().toFixed(2)) : 0.1;
        sound['noise'] = seed ? parseFloat((Math.pow(this.R(), 3) * 5).toFixed(1)) : 0;
        sound['modulation'] = seed ? parseFloat((Math.pow(this.R(), 5) * 99).toFixed(1)) : 0;
        sound['modulationPhase'] = seed ? parseFloat(this.R().toFixed(2)) : 0;
        this.r = rSave; // restore rand seed
        return sound;
    };
    // random seeded float
    ZZFXLib.prototype.R = function () {
        this.r ^= this.r << 13;
        this.r ^= this.r >> 7;
        this.r ^= this.r << 17;
        return (Math.abs(this.r) % 1e9) / 1e9;
    };
    return ZZFXLib;
}());
export { ZZFXLib };
